import { headline, subtitle } from "../landing-copy";
import FadeInLine from "./FadeInLine";

/** When the second headline line finishes its last character fade. */
const HEADLINE_END =
  0.22 + (headline.secondary.length - 1) * 0.01 + 0.08;
const LINE_STEP = 0.22;
/** Matches `.fadein-line` animation duration in index.css */
const FADE_DUR = 0.35;

/** CTA starts after the last subtitle line has finished fading in. */
export const CTA_DELAY =
  HEADLINE_END + subtitle.lines.length * LINE_STEP + FADE_DUR;

export default function Subtitle() {
  return (
    <>
      <p className="subtitle-lead">
        <FadeInLine text={subtitle.lead} delay={HEADLINE_END} block />
      </p>

      <p className="subtitle">
        <FadeInLine
          text={subtitle.lines[0]}
          delay={HEADLINE_END + 1 * LINE_STEP}
          block
        />
        <FadeInLine
          text={subtitle.lines[1]}
          delay={HEADLINE_END + 2 * LINE_STEP}
          block
        />
        <FadeInLine
          text={subtitle.lines[2]}
          delay={HEADLINE_END + 3 * LINE_STEP}
          block
        />
        <FadeInLine
          text={subtitle.lines[3]}
          delay={HEADLINE_END + 4 * LINE_STEP}
          block
        />
      </p>
    </>
  );
}
